<template lang="html">
  <div class="shopcart">

    <div class="shopcart-wrapper">
      <div class="left" @click="shopcartClick">
        <span class="icon">
          <div class="icon-shopping_cart" :class="{active:totalCount}">
            <i class="fas fa-shopping-bag"></i>
          </div>
          <div class="number" v-show="totalCount > 0">{{totalCount}}</div>
        </span>
        <span class="price" :class="{active:totalPrice}">{{formatNumber(totalPrice)}} تومان</span>
      </div>
      <div class="right" :class="{payEnable:payEnable}" @click="pay">
        <div class="content">{{payEnableStr}}</div>
      </div>
    </div>

    <transition name="fold">
    <div class="shoplist" v-show="showShopList">
      <div class="title">
        <div class="left">سبد خرید</div>
        <div class="right" @click="emptyList">پاک کردن سبد خرید</div>
      </div>
      <div class="itemlist-wrapper" ref="listWrapper">
        <ul class="itemlist">
          <li class="item" v-for="cartItem in cartItems" v-bind:key="cartItem.product_id">
            <div class="content">
                <img class="image img-fluid" :src="cartItem.product.image ? cartItem.product.image.url : defaultImage" />
              <span class="name">{{cartItem.product.name}}</span>
              <span class="price">{{formatNumber(cartItem.product.price * cartItem.quantity)}} تومان</span>
              <span class="countctrl-wrapper">
                <countctrl :cartItem="cartItem"></countctrl>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    </transition>
    <transition>
    <div class="shoplist-mask" v-show="showShopList" @click="shopcartClick"></div>
    </transition>
  </div>
</template>

<script>
import countctrl from "./CountCtrl";
import bscroll from "better-scroll";
export default {
  data: function () {
    return {
      payEnable: false,
      showShopList: false,
      payEnableStr: " 0  تومان",
    };
  },
  props: {
    seller: {
      Type: Object,
    },
  },
  components: {
    countctrl,
  },

  computed: {
    cartItems() {
      return this.$store.getters.cartItems;
    },
    totalPrice: {
      get: function () {
        let price = 0;
        this.cartItems.forEach((cartItem) => {
          price += cartItem.product.price * cartItem.quantity;
        });
        return price;
      },
    },
    totalCount: {
      get: function () {
        let count = 0;
        this.cartItems.forEach((cartItem) => {
          count += cartItem.quantity;
        });

        return count;
      },
    },
  },

  watch: {
    totalCount: {
      handler: function (newVal) {
        if (newVal == 0) this.showShopList = false;
      },
    },

    totalPrice: function (newVal) {
      if (newVal == 0) {
        this.payEnable = false;
        this.payEnableStr = " 0 " + " تومان";
      } else if (newVal <= 0) {
        this.payEnable = false;
        this.payEnableStr = "تومان" + newVal;
      } else {
        this.payEnable = true;
        this.payEnableStr = "ادامه خرید";
      }
    },
  },

  methods: {
    shopcartClick: function () {
      if (!this.totalCount) return;
      this.showShopList = !this.showShopList;
      if (this.showShopList) {
        this.$nextTick(() => {
          if (!this.listScroll) {
            this.listScroll = new bscroll(this.$refs.listWrapper, {
              click: true,
            });
          } else {
            this.listScroll.refresh();
          }
        });
      }
    },
    emptyList: function () {
      this.$store.dispatch("clearCart");
    },
    pay: function () {
      if (this.payEnable == false) return;

      this.$router.push('address', () => {
          //this.$root.$emit('setMessageTags')
       })
      //this.emptyList();
    },
  },
};
</script>

<style lang="css">
.shopcart {
  position: fixed;
  width: 100%;
  height: 45px;
  left: 0;
  bottom: 0;
  z-index: 1000;
}
.shopcart .shopcart-wrapper {
  display: flex;
  height: 100%;
  background: #141d27;
  z-index: 50;
}
.shopcart .shopcart-wrapper .left {
  display: flex;
  align-items: center;
  flex: auto;
  z-index: 50;
  background: #141d27;
}
.shopcart .shopcart-wrapper .left .icon {
  background: #141c27;
  width: 56px;
  height: 56px;
  margin: 0 12px;
  border-radius: 50%;
  padding: 6px;
  display: inline-block;
  position: relative;
  top: -6px;
  vertical-align: top;
}
.shopcart .shopcart-wrapper .left .icon .icon-shopping_cart {
  width: 100%;
  height: 100%;
  line-height: 48px;
  border-radius: 50%;
  font-size: 24px;
  text-align: center;
  display: inline-block;
  color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.2);
}
.shopcart .shopcart-wrapper .left .icon .icon-shopping_cart.active {
  color: #fff;
  background: rgb(0, 160, 260);
}
.shopcart .shopcart-wrapper .left .icon .number {
  padding: 4px 8px;
  font-size: 12px;
  line-height: 12px;
  border-radius: 10px;
  color: white;
  background: red;
  position: absolute;
  top: 0;
  right: 0;
}

.shopcart .shopcart-wrapper .left .price {
  display: inline-block;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.4);
  padding: 12px;
}
.shopcart .shopcart-wrapper .left .price.active {
  color: #fff;
}
.shopcart .shopcart-wrapper .left .description {
  color: rgba(255, 255, 255, 0.4);
  font-size: 10px;
  line-height: 10px;
  display: inline-block;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  margin: 12px 0;
  padding: 6px 12px;
  font-weight: 200;
}
.shopcart .shopcart-wrapper .right {
  width: 105px;
  flex: 0 0 105px;
  color: rgba(255, 255, 255, 0.4);
  background: #32373e;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}
.shopcart .shopcart-wrapper .right .content {
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
}
.shopcart .shopcart-wrapper .right.payEnable {
  color: #fff;
  background: #00b43c;
}

/* shoplist */
.shopcart .shoplist {
  background: rgba(255, 255, 255, 0.95);
  transform: translate3d(0, -100%, 0);
  transition: all 0.5s ease;
  padding-bottom: 45px;
}
/* shoplist transiton */
.shopcart .shoplist.fold-enter {
  transform: translate3d(0, 0, 0);
}
.shopcart .shoplist.fold-leave-active {
  transform: translate3d(0, 0, 0);
}

.shopcart .shoplist .title {
  width: 100%;
  height: 40px;
  background: #f3f5f7;
  border-bottom: 1px solid rgba(7, 17, 27, 0.1);
}
.shopcart .shoplist .title .left {
  float: left;
  line-height: 40px;
  font-size: 14px;
  color: rgba(7, 17, 27, 0.7);
  padding: 0 18px;
}
.shopcart .shoplist .title .right {
  float: right;
  line-height: 40px;
  color: rgb(0, 160, 220);
  padding: 0 18px;
}

.shopcart .itemlist-wrapper {
  max-height: 70vh;
  overflow: auto;
}
.shopcart .shoplist .itemlist {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.shopcart .shoplist .itemlist .item {
  padding: 0;
  margin: 0;
  padding: 0 18px;
}
.shopcart .shoplist .itemlist .item .content {
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid rgba(7, 17, 27, 0.2);
}
.shopcart .shoplist .itemlist .item:last-child .content {
  border-bottom: 0;
}
.shopcart .shoplist .itemlist .item .image{
  max-width: 7%;
  height: auto;
  margin: 0.5rem 1rem ;
}
.shopcart .shoplist .itemlist .item .name,
.shopcart .shoplist .itemlist .item .price,
.shopcart .shoplist .itemlist .item .countctrl-wrapper {
  display: inline-block;
  flex: auto;
}
.shopcart .shoplist .itemlist .item .name {
  font-size: 14px;
  line-height: 24px;
}
.shopcart .shoplist .itemlist .item .price {
  flex-grow: 0;
  color: red;
  padding: 0 12px 0 18px;
  font-size: 14px;
}
/* .shopcart .shoplist .itemlist .item .price:first-letter {
  font-size: 12px;
  font-weight: normal;
} */
.shopcart .shoplist .itemlist .item .countctrl-wrapper {
  flex-grow: 0;
  text-align: center;
  line-height: 24px;
  color: rgb(0, 160, 220);
}

.shopcart .shoplist-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: -1;
  transition: all 0.4s;
}
.shopcart .shoplist-mask.v-enter,
.shopcart .shoplist-mask.v-leave-active {
  opacity: 0;
}
.shopcart .shoplist-mask.v-enter-to {
  opacity: 1;
}

</style>
